import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { EastSlider } from '../EastSlider/EastSlider';

@Component
export class ProductGallery extends ThemeComponent {
    @Ref() zoomButton!: HTMLButtonElement;
    @Ref() gallery!: EastSlider;
    @Prop({default: []}) zoomData!: [];

    init() {
        this.initZoomGallery();
    }

    initZoomGallery() {
        if (this.zoomData.length) {

            const lightbox = new PhotoSwipeLightbox({
                dataSource: this.zoomData,
                pswpModule: () => import('photoswipe')
            });

            lightbox.init();

            this.$listen(this.zoomButton, 'click', () => {
                const index = this.gallery.getActiveindex()? this.gallery.getActiveindex() as number: 0;
                lightbox.loadAndOpen(index, this.zoomData, null);
            });
        }
    }
}
